import React, { createContext, useState, useEffect } from "react"

export const MaintenanceContext = createContext({
  isInMaintenance: false,
  isLoading: true,
})

const POLL_INTERVAL =
  parseInt(process.env.GATSBY_MAINTENANCE_POLL_INTERVAL, 10) || 60000

const MaintenanceProvider = ({ children }) => {
  const [isInMaintenance, setIsInMaintenance] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const checkStatus = () => {
      fetch(`${process.env.GATSBY_API_URL}configs/maintenance-status/`)
        .then(res => res.json())
        .then(data => setIsInMaintenance(data.is_in_maintenance ?? false))
        .catch(() => setIsInMaintenance(false))
        .finally(() => setIsLoading(false))
    }

    checkStatus()
    const intervalId = setInterval(checkStatus, POLL_INTERVAL)

    return () => clearInterval(intervalId)
  }, [])

  return (
    <MaintenanceContext.Provider value={{ isInMaintenance, isLoading }}>
      {children}
    </MaintenanceContext.Provider>
  )
}

export default MaintenanceProvider
